import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "FK_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#FK_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "FK_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#FK_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M25.951 19.713c-1.029 0-1.745-.242-2.254-.666-.512-.425-.848-1.059-1.062-1.903-.215-.846-.303-1.881-.336-3.083-.023-.845-.019-1.762-.014-2.746l.004-1.033h7.415c.133 2.408.18 4.754-.29 6.513-.243.904-.617 1.63-1.165 2.13-.544.495-1.282.788-2.298.788z",
      fill: "#6DC2FF",
      stroke: "#F7FCFF",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "FK_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 22,
      y: 10,
      width: 9,
      height: 10
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M25.951 19.713c-1.029 0-1.745-.242-2.254-.666-.512-.425-.848-1.059-1.062-1.903-.215-.846-.303-1.881-.336-3.083-.023-.845-.019-1.762-.014-2.746l.004-1.033h7.415c.133 2.408.18 4.754-.29 6.513-.243.904-.617 1.63-1.165 2.13-.544.495-1.282.788-2.298.788z",
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: 0.5
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#FK_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.523 13.586s-.394-.292-.564-.764c-.169-.473-.504-1.732-.504-1.842 0-.109-.445 0-.445 0s.006-.532.174-.532c.168 0 .175-.494.583-.37.408.125.728.58 1.144.58.416 0 2.154.133 2.433.133.28 0 1.016.59 1.016 1.031 0 .442-.2 1.1-.359 1.1-.158 0-.356.382-.657.256-.3-.127-1.017-.387-1.66-.257-.641.13-.773.049-.773.257 0 .208-.388.408-.388.408z",
      fill: "#E1E5E8"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.602 13.278h5.155l-.888 1.148h-3.643l-.624-1.148z",
      fill: "#49801E"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M23.533 18.295s.891.318 1.264.28c.412-.043.777-.514 1.053-.514.275 0 .804.47 1.216.514.373.038 1.1-.28 1.1-.28M22.555 16.936c.308-.261.978-.28.978-.28s.891.319 1.264.28c.412-.043.777-.513 1.053-.513.275 0 .805.47 1.216.513.373.039 1.1-.28 1.1-.28s.407-.457.917.026",
      stroke: "#fff",
      strokeWidth: 1.067
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.462 15.529l-.675-.827c.265-.215.709-.428 1.357-.663l.314-.015c.672.173 1.121.247 1.286.23.054-.005.145-.049.31-.159.471-.312.517-.337.796-.337.255 0 .308.024.842.313.099.053.136.072.19.098a.861.861 0 00.237.086c.129.013.387-.047.748-.193.47-.426 1.064-.382 1.576.084.341.311.615.562.822.754l-.725.782c-.204-.189-.476-.438-.816-.747-.134-.123-.105-.123-.165-.058l-.185.13c-.56.237-1.002.345-1.36.31a1.765 1.765 0 01-.594-.187 5.276 5.276 0 01-.235-.12c-.258-.14-.355-.185-.335-.185.045 0-.017.034-.206.16-.303.2-.514.303-.794.331-.309.031-.79-.043-1.495-.218-.457.173-.761.323-.893.43z",
      fill: "#fff"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.964 18.394s.984.942.39 1.58c-.594.64-1.14.268-1.14.268M29.05 18.394s-.984.942-.39 1.58c.594.64 1.139.268 1.139.268",
      stroke: "#B85F3C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.322 19.153s1.695 1.62 3.78 1.62c2.083 0 3.76-1.237 3.76-1.237",
      stroke: "#CB8B73"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#2B409A", d: "M0 0h18v14H0z" }), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "FK_svg__d",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 14
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h18v14H0z" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#FK_svg__d)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-2.006 13l3.961 1.737L18.088 1.89l2.09-2.582-4.236-.58-6.58 5.537-5.297 3.73L-2.005 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-1.463 14.216l2.018 1.009L19.428-.933h-2.833l-18.058 15.15z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.004 13l-3.961 1.737L-.09 1.89-2.18-.693l4.236-.58 6.58 5.537 5.297 3.73L20.003 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.87 13.874l-2.019 1.008-8.036-6.918-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.927 7.004 5.943z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "FK_svg__e",
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -2,
      width: 22,
      height: 18,
      fill: "#000"
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M-2-2h22v18H-2z" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.985 0v-1.5h-1.5V0h1.5zm2 0h1.5v-1.5h-1.5V0zm-2 6v1.5h1.5V6h-1.5zM0 6V4.5h-1.5V6H0zm0 2h-1.5v1.5H0V8zm7.985 0h1.5V6.5h-1.5V8zm0 6h-1.5v1.5h1.5V14zm2 0v1.5h1.5V14h-1.5zm0-6V6.5h-1.5V8h1.5zM18 8v1.5h1.5V8H18zm0-2h1.5V4.5H18V6zM9.985 6h-1.5v1.5h1.5V6zm-2-4.5h2v-3h-2v3zm1.5 4.5V0h-3v6h3zM0 7.5h7.985v-3H0v3zm1.5.5V6h-3v2h3zm6.485-1.5H0v3h7.985v-3zm1.5 7.5V8h-3v6h3zm.5-1.5h-2v3h2v-3zM8.485 8v6h3V8h-3zM18 6.5H9.985v3H18v-3zM16.5 6v2h3V6h-3zM9.985 7.5H18v-3H9.985v3zM8.485 0v6h3V0h-3z",
      fill: "#F7FCFF",
      mask: "url(#FK_svg__e)"
    }
  ))))
);
export {
  t as default
};
